export const getFilteredOptions = (options, selectedItems, selectAllOption) => {
  const allSelected = selectedItems.some((item) => item.id === "all");

  return [
    {
      ...selectAllOption,
      disabled: selectedItems.length > 0 && !allSelected, // disable "All" if others selected
    },
    ...options.map((opt) => ({
      ...opt,
      disabled: allSelected, // disable others if "All" selected
    })),
  ];
};

export const selectAllOption = {
  id: "all",
  name: "All",
};

export const selectAllUsers = {
  id: "all",
  firstName: "All",
  lastName: "Users",
};

export const PROJECT_TYPES = [
  { id: 1, name: "Architecture", value: "ARCHITECTURE" },
  { id: 2, name: "Interior", value: "INTERIOR" },
  { id: 3, name: "POP", value: "POP" },
  { id: 4, name: "PMC", value: "PMC" },
  { id: 5, name: "Construction", value: "CONSTRUCTION" },
];
